import { Injectable, Optional } from '@angular/core';
import { INDDI18nServiceConfigResources, NDDI18nServiceConfigResources, NDDTranslationResourceService } from '@ndk/ng-translation';

/**
 * Interface com atributos necessários para configuração i18n.
 *
 * @export
 * @interface INDDFormsI18nServiceConfigResources
 * @extends {INDDI18nServiceConfigResources}
 */
export interface INDDFormsI18nServiceConfigResources extends INDDI18nServiceConfigResources {
    canDeactivateMessage?: string;
    invalidDefault?: string;
    invalidEmail?: string;
    invalidMax?: string;
    invalidMaxDate?: string,
    invalidMaxDecimalDigits?: string;
    invalidMaxLength?: string;
    invalidMin?: string;
    invalidMinDate?: string,
    invalidMinDecimalDigits?: string;
    invalidMinLength?: string;
    invalidTimeRange?: string;
    invalidPattern?: string;
    invalidRequired?: string;
    fieldsetCollapse?: string;
    fieldsetExpand?: string;
}

/**
 * Configurações i18n gerais do módulo.
 *
 * @export
 * @class NDDFormsI18nServiceConfig
 * @implements {NDDI18nServiceConfigResources}
 */
export class NDDFormsI18nServiceConfig implements NDDI18nServiceConfigResources {
    public i18n: boolean;
    public resources: INDDFormsI18nServiceConfigResources = {
        canDeactivateMessage: 'Há dados não salvos. Deseja descartar as alterações?',
        invalidDefault: 'Campo inválido',
        invalidEmail: 'E-mail inválido',
        invalidMax: 'Valor máximo inválido',
        invalidMaxDate: 'Data máxima inválida',
        invalidMaxDecimalDigits: 'Quantidade máxima de dígitos decimais inválida',
        invalidMaxLength: 'Quantidade máxima de caracteres inválida',
        invalidMin: 'Valor mínimo inválido',
        invalidMinDate: 'Data mínima inválida',
        invalidMinDecimalDigits: 'Quantidade mínima de dígitos decimais inválida',
        invalidMinLength: 'Quantidade mínima de caracteres inválida',
        invalidTimeRange: 'Intervalo de tempo inválido',
        invalidPattern: 'Formato inválido',
        invalidRequired: 'Campo obrigatório',
        fieldsetCollapse: 'Ocultar',
        fieldsetExpand: 'Expandir',
    };
}

/** Serviço de configuração i18n. */
@Injectable()
export class NDDFormsI18nService extends NDDTranslationResourceService {
    constructor(@Optional() config: NDDFormsI18nServiceConfig) {
        super(config, new NDDFormsI18nServiceConfig());
    }
}
